export default {"src":"/_next/static/media/icon_03.12c82a74.svg","height":44,"width":44};